<template>
  <div>

    <el-form :model="Form" label-position="top" status-icon ref="Form" size="mini" label-width="120px">

      <div class="card">

        <div class="card-header bg-transparent">

          <div class="row">
            <div class="col-6">
              <h3 class="card-title mb-0"> {{$t('fatura.bas')}} </h3>
              <small class="md-truncate flex">{{$t('fatura.bas1')}}</small>
            </div>

            <div class="col-6 text-right">

            </div>


          </div>

        </div>


        <div class="card-body p-3">


          <!---===== Print Area =======-->
          <div id="print-area">
            <div class="row">
              <div class="col-md-6">
                <h4 class="font-weight-bold">{{$t('fatura.bas2')}}</h4>
                <p class="col-sm-6 p-0">
                  <el-form-item
                    prop="Fatura.fno"
                    autocomplete="off"
                    :rules="[{ required: true, message: $t('bos') }]"
                  >
                    <el-input type="text" v-model="Form.Fatura.fno"
                              autocomplete="off" :placeholder="$t('fatura.fno')"></el-input>
                  </el-form-item>
                  <button type="button" class="btn btn-sm btn-info" @click="FNO()">{{$t("fatura.fnouret")}}</button>

                </p>
              </div>
              <div class="col-md-6 text-sm-right">
                <div class="row text-sm-right">

                  <div class="col-sm-8">{{$t('fatura.kategori')}}:</div>
                  <div class="col-sm-4">
                    <el-form-item
                      prop="Fatura.Kategori_id"
                      label-position="left"
                      :rules="[{ required: true, message: $t('bos') },]"
                    >
                      <el-select v-model="Form.Fatura.Kategori_id">
                        <el-option
                          v-for="index in Kategori"
                          :key="index.id"
                          :label="index.adi"
                          :value="index.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="col-sm-8">{{$t('fatura.dtarih')}}:</div>
                  <div class="col-sm-4">
                    <el-form-item
                      prop="Fatura.dtarihi"
                      autocomplete="off"
                      :rules="[{ required: true, message: $t('bos') }]"
                    >
                      <el-date-picker
                        v-model="Form.Fatura.dtarihi"
                        type="date"
                        :placeholder="$t('fatura.dtarih')">
                      </el-date-picker>
                    </el-form-item>
                  </div>

                  <div class="col-sm-8">{{$t('fatura.ttarih')}}:</div>
                  <div class="col-sm-4">
                    <el-form-item
                      prop="Fatura.ttarihi"
                      autocomplete="off"
                      :rules="[{ required: true, message: $t('bos') }]"
                    >
                      <el-date-picker
                        v-model="Form.Fatura.ttarihi"
                        type="date"
                        :placeholder="$t('fatura.ttarih')">
                      </el-date-picker>
                    </el-form-item>
                  </div>


                </div>


              </div>
            </div>
            <div class="mt-3 mb-4 border-top"></div>
            <div class="row mb-5">

              <div class="col-md-6 mb-3 mb-sm-0">
                <h5 class="font-weight-bold">{{$t('fatura.firma')}}</h5>
                <div class="col-sm-12 p-0"></div>
                <br>
                <div class="col-sm-12 p-0">{{$t('fatura.aciklama')}}</div>
                <div class="col-sm-6 p-0">

                  <el-form-item
                    prop="Fatura.aciklama"
                    autocomplete="off"
                    :rules="[{ required: true, message: $t('bos') }]">
                    <el-input type="textarea" v-model="Form.Fatura.aciklama"></el-input>
                  </el-form-item>

                </div>
              </div>

              <div class="col-md-6 text-sm-right">
                <h5 class="font-weight-bold">{{$t('fatura.musteri')}}</h5>

                <div class="row">
                  <div class="col-sm-8">{{$t('fatura.cari')}}:</div>
                  <div class="col-sm-4">

                    <el-form-item
                      prop="Fatura.Cari_id"

                      :rules="[{ required: true, message: $t('bos') },]"
                    >
                      <el-select v-model="Form.Fatura.Cari_id">
                        <el-option
                          v-for="index in Cari"
                          :key="index.id"
                          :label="index.adi"
                          :value="index.id"></el-option>
                      </el-select>
                    </el-form-item>

                  </div>

                  <div class="col-sm-12"></div>

                </div>


              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-hover mb-4">
                  <thead class="bg-gray-300">
                  <tr>
                    <th>#</th>
                    <th>{{$t('fatura.urun')}}</th>
                    <th>{{$t('fatura.miktar')}}</th>
                    <th>{{$t('fatura.bfiyat')}}</th>
                    <th>{{$t('fatura.vergi')}}</th>
                    <th>{{$t('fatura.vtutar')}}</th>
                    <th>{{$t('fatura.indirim')}}</th>
                    <th>{{$t('fatura.toplam')}}</th>
                    <th>
                      <button class="btn btn-primary float-right" type="button" @click="addInput">{{$t('fatura.sekle')}}</button>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(input, key) in Form.Urunler" :key="input.id">
                    <td>{{input.id}}</td>
                    <td>
                      <el-form-item>
                        <el-select v-model="input.Urun" value-key="id" @change="bilgi(key)">
                          <el-option
                            v-for="item in Urun"
                            :key="item.id"
                            :label="item.adi"
                            :value="{id:item.id,para:item.satis}"></el-option>
                        </el-select>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item>
                        <el-input type="text" maxlength="12" show-word-limit v-model.number="input.miktar"></el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item>
                        <el-input type="text" :precision="2" :step="0.1" show-word-limit
                                  v-model="input.brfiyat"></el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item>
                        <el-input type="text" maxlength="12" show-word-limit v-model.number="input.vergi"
                                  autocomplete="off"></el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item>
                        <el-input type="text" disabled=""
                                  v-model="input.vergitutar=(input.brfiyat*input.miktar)/100*input.vergi"></el-input>
                      </el-form-item>
                    </td>

                    <td>
                      <el-form-item>
                        <el-input type="text" maxlength="12" show-word-limit v-model.number="input.indirim"></el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item>
                        <el-input type="text" :disabled="true"
                                  v-model="input.toplam=(input.miktar*input.brfiyat)-input.indirim+input.vergitutar"></el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <button class="btn btn-outline-secondary float-right" type="button" @click="Sil(key)"
                              v-if="key!=0">Sil
                      </button>

                    </td>
                  </tr>

                  </tbody>
                </table>

              </div>

              <div class="col-md-12 pull-right">
                <div class="invoice-summary pull-right">
                  <p>{{$t('fatura.toplam')}}: <span>{{ toplam(2) | currency }}</span></p>
                  <p>{{$t('fatura.ktoplam')}}: <span>{{ toplam(1) | currency }}</span></p>
                  <h5 class="font-weight-bold">{{$t('fatura.gtoplam')}}: <span> {{ toplam(0) | currency }}</span></h5>
                </div>
              </div>

              <div class="col-md-12 pull-right">
                <el-button type="primary" @click="onSubmit('Form')">{{$t('kaydet')}}</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>



    </el-form>

  </div>
</template>

<script>
  import notification from "@/notification";

  export default {
    data() {
      return {
        Cari: [],
        Kategori: [],
        Urun: [],
        search: '',
        Form: {
          Fatura: {
            Cari_id: '',
            aciklama: '',
            Kategori_id: '',
            dtarihi: '',
            ttarihi: '',
            fno: '',
            alttoplam: '',
            vergi: '',
            indirim: '',
            findirim: '',
            toplam: '',
            odurum: '',
            tur: 2,
          },

          Urunler: [{

            id: '1',
            Urun_id: '',
            miktar: '1',
            brfiyat: '0',
            vergi: '19',
            vergitutar: '',
            indirim: '0',
            toplam: '0',
          }],


        },
        counter: 1,


      }
    },
    methods: {
      addInput() {
        this.Form.Urunler.push({
          id: `${++this.counter}`,
          Urun_id: '',
          miktar: '1',
          brfiyat: '0',
          vergi: '18',
          indirim: '0',
          toplam: '0',
        });
      },
      KategoriListele() {
        this.$store.dispatch("dataver", {method: "get", url: "/kategori/2"})
          .then(response => {
            if (response.Status == 'OK') {
              this.Kategori = response.Data;
              this.Form.Kategori_id = response.Data[0].id;
            } else {

            }
          });
      },
      CariListele() {
        this.$store.dispatch("dataver", {method: "get", url: "/cari"})
          .then(response => {
            if (response.Status == 'OK') {
              this.Cari = response.Data;
              this.Form.Cari_id = response.Data[0].id;
            } else {

            }
          });
      },
      UrunListele() {
        this.$store.dispatch("dataver", {method: "get", url: "/urun"})
          .then(response => {
            if (response.Status == 'OK') {
              this.Urun = response.Data;
              this.Form.Urun_id = response.Data[0].id;
              console.log(this.Urun)
            } else {

            }
          });
      },
      Sil(index) {
        this.$delete(this.Form.Urunler, index);
      },
      bilgi(key) {
        this.Form.Urunler[key].Urun_id = (this.Form.Urunler[key].Urun.id.replace(',', '.'))
        this.Form.Urunler[key].brfiyat = (this.Form.Urunler[key].Urun.para.replace(',', '.'))
      },
      toplam(tur) {
        //Genel Toplam
        if (tur == 0) {
          var VeriT = this.Form.Urunler.reduce((acc, item) => acc + Number(item.toplam), 0);
          this.Form.Fatura.toplam = VeriT;
        }
        //Kdv
        if (tur == 1) {
          var VeriT = this.Form.Urunler.reduce((acc, item) => acc + Number(item.vergitutar), 0);
          this.Form.Fatura.vergi = VeriT;
        }
        //Toplam
        if (tur == 2) {
          var VeriT = this.Form.Urunler.reduce((acc, item) => acc + Number(item.toplam - item.vergitutar), 0);
          this.Form.Fatura.alttoplam = VeriT;
        }
        return VeriT;
      },

      onSubmit(formName) {

        this.$refs[formName].validate((valid) => {
          console.log(valid);
          if (valid) {


            this.$store.dispatch("dataver", {
              method: 'post',
              url: '/fatura/',
              data: this.Form
            }).then(response => {
              this.$router.push("/gelir/fatura");
              this.$message({
                type: 'success',
                message: this.$t('siluyari.1')
              });
            })


          }
        });
      },

      FNO(){
        this.$store.dispatch("dataver", {method: "get", url: "/bilgi/faturano"})
          .then(response => {
            console.log(response);
            this.Form.Fatura.fno = response;
          });
      }

    },
    created() {
      this.KategoriListele();
      this.CariListele();
      this.UrunListele();
    },

    computed: {
      total() {
        return this.Form.Urunler.reduce((acc, item) => acc + Number(item.toplam), 0);
      }
    },
    filters: {
      currency(value) {
        return value.toFixed(2);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/gelir/fatura/yeni.vue